/**
 * Formato de dinero, fechas y duraciones.
 *
 * El peso colombiano no usa decimales en el punto de venta: nadie cobra
 * $12.500,50. Se redondea al entero para mostrar, pero los cálculos siguen
 * haciéndose sobre el string original que manda Postgres.
 */

const FORMATO_COP = new Intl.NumberFormat('es-CO', {
  style: 'currency',
  currency: 'COP',
  maximumFractionDigits: 0,
});

/** Acepta lo que devuelve la API (string) o un número ya calculado. */
export function cop(valor: string | number | null | undefined): string {
  const n = typeof valor === 'string' ? Number(valor) : (valor ?? 0);
  return FORMATO_COP.format(Number.isFinite(n) ? n : 0);
}

/** Suma segura de montos que llegan como string desde Postgres. */
export function sumar(...valores: (string | number)[]): number {
  return valores.reduce<number>((t, v) => t + (typeof v === 'string' ? Number(v) : v), 0);
}

export const pad2 = (n: number | string): string => String(n).padStart(2, '0');

export function hhmm(fecha: string | number | Date | null | undefined): string {
  if (!fecha) return '--:--';
  return new Date(fecha).toLocaleTimeString('es-CO', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
}

export function fechaCorta(fecha: string | number | Date = Date.now()): string {
  return new Date(fecha).toLocaleDateString('es-CO', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
}

/** Minutos transcurridos desde que se abrió la mesa. */
export function minutosDesde(fecha: string | number | Date | null | undefined): number {
  if (!fecha) return 0;
  return Math.max(0, Math.floor((Date.now() - new Date(fecha).getTime()) / 60000));
}

/** "1:24" para el anillo del panel lateral. */
export function duracion(minutos: number): string {
  return `${pad2(Math.floor(minutos / 60))}:${pad2(minutos % 60)}`;
}
